// extracted by mini-css-extract-plugin
module.exports = {"root":"Button-root-1oADY","default":"Button-default-oFNCC","round":"Button-round-wnOM8","primary":"Button-primary-1-JdE","secondary":"Button-secondary-1oTed"};